import { UserInfo } from "@/components/user/UserInfo";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

export const ProfileSettings = () => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Profil</CardTitle>
      </CardHeader>
      <CardContent>
        <UserInfo />
      </CardContent>
    </Card>
  );
};